import { Injectable } from '@angular/core';

/** Default dropdown configuration */
@Injectable()
export class DropdownConfig {
  /** default dropdown auto closing behavior */
  autoClose = true;
}
